export default "__VITE_ASSET__DZTdHD$N__"